// Libraries
import React from 'react';
import styled, {css} from 'styled-components/macro';
import {GridThemeProvider, media, Row, Col, Container} from 'library/styled-bs-grid';
import {isEmpty} from 'utils/equal';
import uniqueId from 'lodash/uniqueId';

// Components
import Button from 'components/atoms/Button';

interface IProps {
    type: 'success'|'error'|'confirm';
    title: string;
    message: string;
    code?: string;
    buttons: Array<{
        text: string,
        type: 'default'|'danger',
        onClick?: Function;
    }>;
}

const Dialog: React.FC<IProps> = ({
    type,
    title,
    message,
    code,
    buttons,
}) => {
    const handleClickDialog = (onClick: Function | undefined) => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <DialogRoot>
            <Title type={type}>{title}</Title>
            <MessageContent>{message}</MessageContent>

            {!isEmpty(code) && (
                <StatusCode>{`Code: ${code}`}</StatusCode>
            )}


            <GridThemeProvider gridTheme={{
                gridGutterWidth: 5,
            }}>
                <Container fluid>
                    <Row className="justify-content-center">
                        {buttons.map(row => (
                            <Col
                                key={uniqueId('modalButton_')}
                                className="d-flex justify-content-center"
                                col
                            >
                                <ModalButton
                                    isBlock
                                    themeType={row.type}
                                    size="small"
                                    onClick={() => handleClickDialog(row.onClick)}
                                >
                                    {row.text}
                                </ModalButton>
                            </Col>
                        ))}
                    </Row>
                </Container>

            </GridThemeProvider>

        </DialogRoot>
    );
};

export default Dialog;



const ModalButton = styled(Button)`
    max-width: 180px;

    ${media.lg`
        max-width: initial;
        font-size: 16px;
    `}
`;

const StatusCode = styled.div`
    font-size: 12px;
    color: #9d9a9a;
    margin-bottom: 10px;
`;

const MessageContent = styled.div`
    font-size: 14px;
    text-align: center;
    color: #282731;
    font-weight: 900;
    padding-bottom: 15px;

    ${media.lg`
        font-size: 16px;
        padding-bottom: 25px;
    `}
`;

const Title = styled.div<any>`
    font-size: 16px;
    font-weight: 900;
    margin-bottom: 10px;
    color: ${props => props.type === 'success' ? '#7ed321' : '#ff4b4b'};

    ${props => props.type === 'confirm' && css`
        color: #FABD32;
    `};

    ${media.lg`
        font-size: 20px;
    `}
`;

const DialogRoot = styled.div`
    width: 280px;
    border-radius: 5px;
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    padding: 16px 20px 20px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${media.lg`
        width: 400px;
        padding: 30px 50px;
    `}
`;
